import React, { ReactNode } from 'react'

import { createFastContext } from '@rst/libs-ts'
import { useMemo } from 'react'

const { Provider, useCtx } = createFastContext<{
	enabled: boolean
	blocks?: Record<string, boolean>
}>({
	enabled: false,
	blocks: {},
})

const useEnableAnimation = () => {
	const { enabled, blocks = null } = useCtx()

	return useMemo(() => ({ enabled, blocks }), [enabled, blocks])
}

const EnableAnimation = ({
	children,
	blocks,
}: {
	children?: ReactNode
	blocks?: Record<string, boolean>
}) => {
	return <Provider value={{ enabled: true, blocks }}>{children}</Provider>
}

const DisableAnimation = ({ children }: { children?: ReactNode }) => (
	<Provider value={{ enabled: false }}>{children}</Provider>
)

export { EnableAnimation, DisableAnimation, useEnableAnimation }
